export default "__VITE_ASSET__5222ec71__"